import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Form from './form';
import {Button,Typography} from '@material-ui/core';


const styles = theme => ({
  formSection: {
    //flex: 1,  
    height: 500,
    backgroundColor:theme.palette.primary.main,
    display: 'flex',
    justifyContent: 'center',
    paddingTop:'50px',
  },
  socialSection: {
    //flex: 1,  
    height: 100,
    backgroundColor:theme.palette.secondary.main,
    display: 'flex',
    justifyContent: 'flex-start',
    margin:'0 40px',
  },
  separator:{
    color:'#202124',
    display:'flex',
    alignSelf:'center'
  },
  button:{
    '&:hover':{
      backgroundColor: '#fff'
    }
  }
  
});





function Contact(props) {
  const { classes } = props;
    return (  
      <div>
        <section className={classes.formSection}>
          <Form/>  
        </section>
        <section className={classes.socialSection}>
            <Button disableRipple={true} disableFocusRipple={true} href="https://github.com/nirajhi" color="primary"  className={classes.button}>
                  Github
            </Button>
            <Typography variant="subheading" color="textSecondary" className={classes.separator}>
              /
          </Typography>    
            <Button disableRipple={true}  disableFocusRipple={true}  href="https://twitter.com/nirajhi" color="primary" className={classes.button}>
                  Twitter
            </Button>
           
            

        </section>
        
      </div>
     ); 
}
    
   

Contact.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Contact);



// WEBPACK FOOTER //
// ./src/component/contact/contact.js